import { DocumentData, DocumentsTypes } from './types';

interface DocumentsParamsTypes {
  cnpj?: string;
  companyId?: number;
}

interface DocumentTypes {
  id: number;
  description: string;
  document_type_id: number;
  expiration_date: any;
}

interface getDocumentsFilterParams {
  currentCompany?: number | null;
  cnpj?: string | null;
  documentsGroups?: Array<number> | null;
  documentStatus?: Array<number> | null;
  documentUpdateTypes?: Array<number> | null;
  nameDescription?: string | null;
}

export const getDocuments = (getDocumentsParams: DocumentsParamsTypes) => {
  const { cnpj, companyId } = getDocumentsParams;
  let params = {};
  if (cnpj) params = { ...params, cnpj };
  if (companyId) params = { ...params, companyId };

  return {
    types: [
      DocumentsTypes.GET_DOCUMENTS_REQUEST,
      DocumentsTypes.GET_DOCUMENTS_SUCCESS,
      DocumentsTypes.GET_DOCUMENTS_FAILURE,
    ],
    promise: (client: any) => client.get('/documentos.json', { params }),
  };
};

export const updateDocument = (document: DocumentTypes, cnpj: string, companyId: number) => {
  const params = {
    document,
    cnpj,
    companyId,
  };

  return {
    types: [
      DocumentsTypes.UPDATE_DOCUMENT_REQUEST,
      DocumentsTypes.UPDATE_DOCUMENT_SUCCESS,
      DocumentsTypes.UPDATE_DOCUMENT_FAILURE,
    ],
    promise: (client: any) => client.patch(`/documento/${document.id}`, params),
    document,
  };
};

export const authenticateDocument = (
  document: DocumentData,
  name: string,
  cpf: string,
  email: string,
  phone: string,
) => {
  const params = {
    document,
    name,
    cpf,
    email,
    phone,
  };

  return {
    types: [
      DocumentsTypes.AUTHENTICATE_DOCUMENT_REQUEST,
      DocumentsTypes.AUTHENTICATE_DOCUMENT_SUCCESS,
      DocumentsTypes.AUTHENTICATE_DOCUMENT_FAILURE,
    ],
    promise: (client: any) => client.post('/authenticated_documents', params),
    document,
  };
};

export const getDocumentsFilter = (params: getDocumentsFilterParams) => {
  return {
    types: [
      DocumentsTypes.FILTER_DOCUMENTS_REQUEST,
      DocumentsTypes.FILTER_DOCUMENTS_SUCCESS,
      DocumentsTypes.FILTER_DOCUMENTS_FAILURE,
    ],
    promise: (client: any) =>
      client.get('/documentos.json', {
        params,
      }),
  };
};

export const serviceSubscriptionStatus = () => ({
  types: [
    DocumentsTypes.SERVICE_SUBSCRIPTION_STATUS_REQUEST,
    DocumentsTypes.SERVICE_SUBSCRIPTION_STATUS_SUCCESS,
    DocumentsTypes.SERVICE_SUBSCRIPTION_STATUS_FAILURE,
  ],
  promise: (client: any) => client.get('/status_assinatura_servico'),
});

export const deleteDocumentFromS3 = (documentId: string | number, companyId: number) => ({
  types: [
    DocumentsTypes.DELETE_DOCUMENT_REQUEST,
    DocumentsTypes.DELETE_DOCUMENT_SUCCESS,
    DocumentsTypes.DELETE_DOCUMENT_FAILURE,
  ],
  promise: (client: any) =>
    client.delete('/documentos/delete_remote_file', { data: { documentId, companyId } }),
  documentId,
});

export const saveDocumentToDatabase = (
  formData: FormData,
  fileName: string,
  updateUploadProgress: (fileName: string, progress: number) => void,
) => {
  return {
    types: [
      DocumentsTypes.SAVE_DOC_DATABASE_REQUEST,
      DocumentsTypes.SAVE_DOC_DATABASE_SUCCESS,
      DocumentsTypes.SAVE_DOC_DATABASE_FAILURE,
    ],
    promise: (client: any) =>
      client.post('/documentos/direct_post', formData, {
        onUploadProgress: (event: any) => {
          const progress: number = Math.round((event.loaded * 100) / event.total);
          updateUploadProgress(fileName, progress);
        },
      }),
    fileName,
  };
};
